import { render } from "./BookingListAdmin.vue?vue&type=template&id=3af4bbc2&scoped=true"
import script from "./BookingListAdmin.vue?vue&type=script&lang=js"
export * from "./BookingListAdmin.vue?vue&type=script&lang=js"

import "./BookingListAdmin.vue?vue&type=style&index=0&id=3af4bbc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af4bbc2"]])

export default __exports__